<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('SMS Setup ')"
          icon="mdi-account-tie"
          class="px-3 py-3"
          color="primary"
        >
          <v-container>
            <v-col>
              <v-row v-for="(sms) in smsGateways" :key="sms.country">
                <v-col cols="12" md="4">
                  <v-text-field :label="$i18n.t('SMS Link')" class="purple-input" v-model="sms.url"></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <z-country-select
                    :label="$i18n.t('Country Code')+ '*'"
                    class="purple-input"
                    v-model="sms.country"
                    isd
                    hideName
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-checkbox v-model="sms.isDefault" :label="$i18n.t('Default')"></v-checkbox>
                </v-col>
                <v-col cols="12" md="2">
                  <v-btn @click="remove()">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-btn small class="float-right" color="blue" @click="add()">
                  <v-icon>mdi-plus</v-icon>
                  {{ $i18n.t("Add SMS Setup") }}
                </v-btn>
              </v-row>
            </v-col>
          </v-container>
          <v-col cols="12" class="text-right">
            <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  corporateConfig = {
    smsGateways: [],
  };
  url = "/api/corp/config/get";
  smsGateways = [];

  get loading() {
    return common.loading;
  }

  add() {
    if (this.smsGateways == null) {
      this.smsGateways = [];
    }
    this.smsGateways.push({
      url: null,
      country: "",
      isDefault: "",
    });
  }

  async mounted() {
    try {
      this.corporateConfig = await doGet(this.url);
      this.smsGateways = this.corporateConfig.smsGateways;
    } catch (e) {
      common.setError(e.message);
    }
  }
  remove(_index) {
    this.smsGateways.splice(_index, 1);
  }

  async save() {
    try {
      common.setLoading(true);
      this.corporateConfig.smsGateways = this.smsGateways;
      await doPost("/api/corp/config/smsGateway/save", this.corporateConfig);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>

